import React from "react";

var trashSvg = function trashSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.002 4V3a1 1 0 0 1 1-1H6a2 2 0 1 1 4 0h4.005a1 1 0 0 1 1 1v1zM2.5 6h11l-.452 9.05a1 1 0 0 1-1 .95H3.952a1 1 0 0 1-.999-.95z"
  }));
};

trashSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var trash = {
  category: 'icon',
  colorable: true,
  name: 'trash',
  svg: trashSvg
};